<template lang='pug'>
section
  s-page-title(title='Редактирование профиля')
  v-card
    v-card-text(v-if='errors.has("common")')
      v-alert(
        :value='errors.has("common")'
        :dismissible='true'
        type='error'
        outline
      )
        | {{ errors.first('common') }}
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12  md4)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='user.name'
            label='Имя'
          )
        v-flex(xs12  md4)
          v-text-field(
            :error='errors.has("phone")'
            :error-messages='errors.first("phone")'
            v-model='user.phone'
            label='Телефон'
            :disabled= "user.confirmed_phone"
          )
        v-flex(xs12  md4)
          v-text-field(
            :error='errors.has("email")'
            :error-messages='errors.first("email")'
            v-model='user.email'
            label='Электронная почта'
            :disabled= "user.confirmed_email"
          )
    //- v-container(grid-list-xl fluid)
    //-   v-layout(wrap)
    //-     v-flex(xs12)
    //-       div(class='title') Паспортные данные
    //-     v-flex(xs12 sm4 md3)
    //-       v-text-field(
    //-         :error='errors.has("passport_num")'
    //-         :error-messages='errors.first("passport_num")'
    //-         v-model='user.passport_num'
    //-         label='Номер'
    //-       )
    //-     v-flex(xs12 sm4 md3)
    //-       v-text-field(
    //-         :error='errors.has("passport_series")'
    //-         :error-messages='errors.first("passport_series")'
    //-         v-model='user.passport_series'
    //-         label='Серия'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='loading'
        @click.native='saveUser'
        color='primary'
        flat
      ) Сохранить
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  components: {},

  data: () => ({
    loading: false
  }),

  created() {
    this.loadUser()
  },

  methods: {
    async saveUser() {
      this.loading = true

      try {
        await this.updateUser(this.user)
        this.showSnack('Профиль успешно обновлен')
      } catch(e) {
        this.$showServerErrors(e)
      }

      this.loading = false
    },

    async loadUser() {
      this.loading = true

      try {
        await this.fetchUser()
      } catch(e) {
        this.showSnack('Не удалось загрузить профиль')
      }

      this.loading = false
    },

    ...mapActions('profile/personal', [
      'fetchUser',
      'updateUser'
    ]),

    ...mapMutations('app', [
      'showSnack'
    ])
  },

  computed: mapState('profile/personal', [
    'user'
  ])
}
</script>
